/*
 * @Author: scg
 * @Date: 2022-03-03 13:40:18
 * @LastEditTime: 2022-03-03 13:41:37
 * @LastEditors: scg
 * @Description:
 */
export default {
  baseURL: 'https://apidemo.spylix.com/', // 请求域名
  fileURL: 'http://demospy.sdkdev.cn/' // 文件下载域名
}



// WEBPACK FOOTER //
// ./src/config/index.js